// extracted by mini-css-extract-plugin
export default {"main":"flat_main__vggIp","logobox":"flat_logobox__OWkz8","logob":"flat_logob__5pYGy","image":"flat_image__IE8eA","logolink":"flat_logolink__zEByX"};